import { ExtendableError } from './extendableError.js';

export class ForbiddenError extends ExtendableError {}
